module.exports = __webpack_public_path__ + "img/deco_bird_red.b6be6361.png";